<script>
  // import { beforeUpdate } from "svelte";
  import DatePicker from "./DatePicker.svelte";
  import PlainInput from "./PlainInput.svelte";
  import AutoCompleteCombo from "./AutoCompleteCombo.svelte";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  const componentTypeMap = {
    date: DatePicker,
    list: AutoCompleteCombo,
    combo: AutoCompleteCombo,
  };
  export let data;
  export let formDetection = false;
  export let props;
  export let gray = false;
</script>

<svelte:component
  this={componentTypeMap[props.type] || PlainInput}
  {...props}
  {formDetection}
  {gray}
  name={undefined}
  bind:value={data}
  on:change={() => dispatch("change", data)}
  on:input={() => dispatch("input", data)}
/>
